import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    tipoDisenioDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TIPO_DISENIO'(state, tipoDisenioId) {
        state.id = tipoDisenioId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_TIPO_DISENIO'(state, tipoDisenio) {
        state.nombre = tipoDisenio.nombre.toUpperCase().trim();
        state.inactivo = tipoDisenio.inactivo;
        state.rowVersion = tipoDisenio.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.tipoDisenioDatos = [];
    },
    'SET_DATOS'(state, tipoDisenioDatos) {
        state.tipoDisenioDatos = tipoDisenioDatos;
    },
};

const getters = {
    getField,

    tipoDisenio(state) {
        return {
            id: state.id,
            nombre: state.nombre.toUpperCase().trim(),
            inactivo: state.inactivo,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, tipoDisenioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TIPO_DISENIO', tipoDisenioId);

            if (tipoDisenioId != 0) {
                apiAxios.get(`tipos-disenios/${tipoDisenioId}/abm`) 
                    .then(res => {
                        commit('SET_TIPO_DISENIO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {} ) {
        return new Promise((resolve, reject) => {
            let tipoDisenio= {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo
            }

            let url = 'tipos-disenios';
            if (state.id != 0) {
                url += '/' + state.id;
                tipoDisenio.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, tipoDisenio)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    inactivar ( {}, tipoDisenioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`tipos-disenios/${tipoDisenioId}/inactivar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },

    getDatos ( { commit }, tipoDisenioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (tipoDisenioId != 0) {
                apiAxios.get(`tipos-disenios/${tipoDisenioId}`) 
                    .then(res => {
                        let datos = [
                            // { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}